import { render } from "./FrontPageDesignViewer.vue?vue&type=template&id=6cbb8f5e&scoped=true"
import script from "./FrontPageDesignViewer.vue?vue&type=script&lang=js"
export * from "./FrontPageDesignViewer.vue?vue&type=script&lang=js"

import "./FrontPageDesignViewer.vue?vue&type=style&index=0&id=6cbb8f5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cbb8f5e"]])

export default __exports__